module.exports = __webpack_public_path__ + "static/media/life-redemption-banner-mobile.8743a7fc.jpg";